import { AfterResponseMiddleware } from '@zapier/transfer-fetch';
import { get } from 'lodash';

import { TransferClientError } from '../errors';

type GulliverErrorBundle = {
  detail: Array<{
    loc: string[];
    msg: string;
    type: string;
  }>;
};

export const throwForStatus: AfterResponseMiddleware = async (res, _, req) => {
  if (res.ok || res.response.type === 'opaqueredirect') {
    return res;
  }

  const commonProps = {
    status: get(res, 'status'),
    requestUrl: get(res, ['response', 'url']),
    requestBody: get(req, 'body'),
  };

  if (typeof res.body === 'string') {
    throw new TransferClientError({
      ...commonProps,
      detail: get(res, 'body'),
    });
  }

  if (!res.body || typeof res.body !== 'object') {
    throw new TransferClientError({
      ...commonProps,
      detail: 'Unknown Error',
    });
  }

  const body = res.body as Record<string, unknown>;

  if (typeof body.detail === 'string') {
    throw new TransferClientError({
      ...commonProps,
      detail: body.detail,
    });
  }

  /**
   * Check if it's a 422  Gulliver error
   * https://zapier.com/api/gulliver/storage/docs/swagger#/Zaps/update_zap
   */
  if (res.status === 422 && body.detail && Array.isArray(body.detail)) {
    throw new TransferClientError({
      ...commonProps,
      detail: get(body as GulliverErrorBundle, ['detail', 0, 'msg']),
    });
  }

  // https://cdn.zappy.app/7e5a65f6f3754f5930d710bf5486850f.png
  if (typeof body.error === 'string') {
    throw new TransferClientError({
      ...commonProps,
      detail: body.error,
    });
  }

  if (Array.isArray(body.errors)) {
    const error = body.errors[0];

    if (typeof error === 'string') {
      throw new TransferClientError({
        ...commonProps,
        detail: error,
      });
    }

    if (error && typeof error === 'object' && !Array.isArray(error)) {
      throw new TransferClientError({
        ...commonProps,
        title: typeof error.title === 'string' ? error.title : undefined,
        detail: typeof error.detail === 'string' ? error.detail : undefined,
        code: typeof error.code === 'string' ? error.code : undefined,
        status: typeof error.status === 'undefined' ? res.status : error.status,
        id: typeof error.id === 'string' ? error.id : undefined,
        meta: error.meta,
      });
    }
  }

  throw new TransferClientError({
    ...commonProps,
    detail: 'Unknown Error',
  });
};

export default throwForStatus;
